<template>
  <v-dialog v-model="dialog" width="70%">
    <v-card outlined>
      <v-card-title class="text-h5 grey lighten-2">
        {{ title }}

        <v-btn
          color="#F6C76F"
          depressed
          @click="exportData"
          class="mt-3 mt-md-0 mx-1 position-absolute export-data-button"
          :loading="exportLoading"
          :disabled="exportLoading"
        >
          <v-icon left>fal fa-file-export</v-icon>
          Export Data
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-skeleton-loader v-if="loading" class="mx-auto" type="table" />

        <template v-else>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            prepend-inner-icon="fa-search"
            label="Search"
            single-line
            hide-details
          />
          <v-data-table
            :headers="table.headers"
            :items="table.rows"
            :items-per-page="15"
            class="elevation-1 mt-5"
            :search="search"
          >
            <template #item.link="{ item }">
              <a target="_blank" :href="item.link"> Go to {{ item.name }} </a>
            </template>

            <template #item.certificateLink="{ item }">
              <v-btn
                depressed
                small
                color="warning"
                @click="openCertificate(item)"
                :loading="item.loading"
                :disabled="item.loading"
              >
                View
              </v-btn>
            </template>

            <template #item.reassign="{ item }">
              <v-menu
                ref="menu"
                v-model="item.menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    small
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Reassign
                  </v-btn>
                </template>
                <v-date-picker v-model="item.date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="item.menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="changeDueDate(item)"
                    :loading="item.loading"
                    :disabled="item.loading"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </template>
          </v-data-table>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="toggleDialog"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { map as _map, isEmpty as _isEmpty } from 'lodash-es';
import moment from 'moment';

export default {
  name: 'ChartsDialog',

  data: () => ({
    dialog: false,
    loading: false,
    title: '',

    table: {
      headers: [],
      rows: [],
    },

    search: '',
    dialogType: '',
    dialogData: null,
  }),

  computed: {
    dealers() {
      return this.$store.state.overviewReport.dealers;
    },

    exportLoading() {
      return this.$store.state.overviewReport.exportLoading;
    },

    users() {
      return this.$store.state.overviewReport.usersFilter;
    },

    searchText() {
      return this.$store.state.overviewReport.searchText;
    },

    categories() {
      return this.$store.state.overviewReport.categories;
    },
  },

  methods: {
    toggleDialog() {
      this.dialog = !this.dialog;
    },

    setDialogTitle(value) {
      this.title = value;
    },

    initDialog(type, data, title) {
      this.setDialogTitle(title);
      this.toggleDialog();
      this.dialogType = type;
      this.dialogData = data;

      this.getData(type);
    },

    getData(type) {
      if (!this.exportLoading) {
        this.loading = true;
      }

      let url = '';
      const params = {};
      const dateRangeType =
        type === 'teamProgress' ? 'teamProgress' : 'myProgress';

      switch (type) {
        case 'certificates':
          url = '/client/reports/lms/overview/certificate';
          params.category = this.dialogData;
          params.dateFrom = this.getDateRange('certifications', 'dateFrom');
          params.dateTo = this.getDateRange('certifications', 'dateTo');
          break;
        case 'myProgress':
        case 'teamProgress':
          url = '/client/reports/lms/overview/progress';

          params.type = type === 'teamProgress' ? 'team' : 'self';
          params.dialogMode = true;
          params.dateFrom = this.getDateRange(dateRangeType, 'dateFrom');
          params.dateTo = this.getDateRange(dateRangeType, 'dateTo');
          params.categories = this.categories[type];
          break;
        default:
          url = '/client/reports/lms/overview';
          params.user = this.dialogData;
      }

      params.dealers = this.dealers.length > 0 ? this.dealers : [];
      params.exportMode = this.exportLoading;
      params.usersFilter = this.getUsersForFilter();
      params.searchText = this.searchText;

      this.$http
        .post(url, params)
        .then(({ data }) => {
          if (this.exportLoading) {
            return window.open(data, '_blank');
          }

          this.loading = false;

          this.table.headers = data.headers;
          this.table.rows = this.processRows(data.rows);
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('overviewReport/setExportLoading', false);
        });
    },

    processRows(rows) {
      return _map(rows, (item) => {
        const result = item;
        result.menu = false;
        result.loading = false;
        result.date = moment().format('YYYY-MM-DD');
        return result;
      });
    },

    openCertificate(item) {
      item.loading = true;

      const url =
        item.type === 'Series'
          ? '/client/reports/lms/progress/download-certificate'
          : '/client/reports/lms/progress/download-playlist-certificate';

      const id = item.originID;
      const userId = item.userID;

      this.$http
        .post(url, {
          id,
          userId,
        })
        .then(({ data }) => {
          item.loading = false;
          window.open(data, '_blank');
        })
        .catch(() => {
          item.loading = false;
        });
    },

    changeDueDate(item) {
      item.loading = true;
      this.$http
        .put(`/client/reports/lms/overview/progress/${item.originID}`, {
          date: item.date,
          type: item.type,
        })
        .then(() => {
          item.loading = false;
          item.menu = false;
          item.dueDate = moment(item.date).format('MM/DD/YYYY');
          this.$notify('success', 'New Due Date has been set');
        })
        .catch(() => {
          item.loading = false;
          this.$notify('error', 'Encountered an error. Please try again!');
        });
    },

    exportData() {
      this.$store.dispatch('overviewReport/setExportLoading', true);
      this.getData(this.dialogType);
    },

    getDateRange(key, type) {
      const date = this.$store.state.overviewReport.componentDates[key][type];

      if (_isEmpty(date)) {
        return null;
      }

      return date;
    },

    getUsersForFilter() {
      if (this.users.length < 1) {
        return [];
      }

      return _map(this.users, (user) => user.id);
    },
  },

  watch: {
    dialog(show) {
      if (show) {
        this.table.headers = [];
        this.table.rows = [];
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.export-data-button
  right 0
  top 7px
</style>
